import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  // EmailIcon,
  // PhoneIcon
} from "@chakra-ui/icons";
import {
  Box,
  Center,
  Flex,
  Heading,
  // HStack,
  Icon,
  // InputRightElement,Input,
  IconButton,
  // InputGroup,Tooltip,
  Image,
  // Link,
  SimpleGrid,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
// import { MdMenu } from "react-icons/md";
import { useEffect, useState } from "react";
// import {
//   FaFacebook,
//   FaInstagram,FaEnvelope,
//   FaLinkedin,FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaPinterest,FaInfoCircle,FaHome,
//   FaTwitter,FaFacebookF,FaProjectDiagram,
//   FaYoutube,FaPaperPlane,FaDownload
// } from "react-icons/fa";
// import Enso from "../../../assets/images/Enso.png";
import Header from "../header/Header";
import ProductDetails from "../products/ProductDetails";
import { useHomeHook } from "./useHomeHook";
import Footer from "../footer/Footer";
// import enso from "../../../assets/images/ensouniversal.mp4";
const MotionBox = motion(Box);

const Home = (props) => {
  const [
    handleMenuEnter,
    handleMenuLeave,
    menuVisible,
    setHoveredItem,
    showBackground,
    fadeOut,
    currentItem,
    handlePrevious,
    handleNext,
    isHovering,
    setIsHovering,
    ImageItem,
  ] = useHomeHook(props);
  // const [hoveredId, setHoveredId] = useState(null);
  // const bgColor = useColorModeValue('white', '#000000');
  // const borderColor = useColorModeValue('#000000', '#000000');
  const [showScroll, setShowScroll] = useState(true);
  // const [productsMenuVisible, setProductsMenuVisible] = useState(false);
  // const featureTextColores = useColorModeValue('#000000', '#000000');
  // const featureBoxBg = useColorModeValue('white', '#000000');
  const featureBoxBorder = useColorModeValue("#FFFFFF", "#FFFFFF");
  const featureHeadingColor = useColorModeValue("#000000", "white");
  const featureTextColor = useColorModeValue("#000000", "#000000");
  // const isMobile = useBreakpointValue({ base: true, md: false });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScroll(false);
      } else {
        setShowScroll(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Box>
      <Box position="relative" width="100%">
        {/* <Box textAlign="center">
      <Flex
        justify="center"
        align="center"
        width="60px"
        overflow="hidden"
        mx="auto"
        mb={1}
      >
        <Image
          src={Enso}
          alt="Enso"
          objectFit="cover"
          width="100%"
          height="100%"
          transition="transform 0.3s ease"
          _hover={{ transform: "scale(1.1)" }}
        />
      </Flex>
      <Heading
        as="h1"
        size="sm"
        color="gold.500"
        fontWeight="bold"
        letterSpacing="wider"
        textShadow="1px 1px 2px rgba(0, 0, 0, 0.2)"
        transition="color 0.3s ease"
        _hover={{ color: "gold.400" }}
      >
        Luxury Living
      </Heading>
    </Box> */}

        {/*  <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
      mt={{ base: 8, md: 10 }}
    >
      <Button
        size={{ base: "md", md: "lg" }}
        colorScheme="whiteAlpha"
        borderWidth="1px"
        borderColor="white"
        _hover={{
          bg: "white",
          color: "black",
          transform: "translateY(-2px)",
        }}
        transition="all 0.3s ease"
      >
        Explore Our Collection
      </Button>
    </MotionBox> */}
        {/* <Header
          handleMenuEnter={handleMenuEnter}
          handleMenuLeave={handleMenuLeave}
          menuVisible={menuVisible}
          setHoveredItem={setHoveredItem}
          productImages={{
            "Sliding Partitions": glass1,
            "Swing Partitions": glass2,
            "Flush Doors": glass3,
            "Bathroom & Wardrobes": glass4,
            "Shower Enclosures": glass5,
            "Led Mirrors": glass6
          }}
          collections={[
            { name: "Sliding Partitions", path: "/product/1" },
            { name: "Swing Partitions", path: "/product/2" },
            { name: "Flush Doors", path: "/product/3" },
            { name: "Bathroom & Wardrobes", path: "/product/4" },
            { name: "Shower Enclosures", path: "/product/5" },
            { name: "Led Mirrors", path: "/product/6" },
          ]}
        /> */}
        <Header
          handleMenuEnter={handleMenuEnter}
          handleMenuLeave={handleMenuLeave}
          menuVisible={menuVisible}
          setHoveredItem={setHoveredItem}
          collections={[
            { name: "Sliding Partitions", path: "/product/1" },
            { name: "Swing Partitions", path: "/product/2" },
            // { name: "Flush Doors", path: "/product/3" },
            { name: "Bathroom & Wardrobes", path: "/product/4" },
            { name: "Shower Enclosures", path: "/product/5" },
            { name: "Led Mirrors", path: "/product/6" },
          ]}
        />
        {/* <Flex
          as="header"
          bg="rgba(0, 0, 0, 0.95)"
          backdropFilter="blur(8px)"
          p={4}
          color="white"
          align="center"
          position="fixed"
          top="0"
          width="100%"
          zIndex="1000"
          transition="all 0.3s ease"
          boxShadow="0 2px 15px rgba(0,0,0,0.1)"
        >
          <Flex
            justify="center"
            align="center"
            width="70px"
            overflow="hidden"
            ml="1rem"
          >
            <Image
              src={Enso}
              alt="Enso"
              objectFit="cover"
              width="80%"
              height="80%"
              transition="transform 0.3s ease"
            />
          </Flex>
          <Heading
            mt={"1.5rem"}
            size="sm"
            color="gold.500"
            fontWeight="bold"
            letterSpacing="wider"
            textShadow="1px 1px 2px rgba(0, 0, 0, 0.2)"
            transition="color 0.3s ease"
            _hover={{ color: "gold.400" }}
          >
            Luxury Living
          </Heading>
          <Spacer />
          {isMobile && (
            <>
              <Icon
                as={MdMenu}
                boxSize="2rem"
                mr={4}
                onClick={(event) =>
                    handleClick(event, "menu")
                }
                _hover={{ cursor: "pointer", color: "teal.300" }}
              />
              {menuVisible && !productsMenuVisible && (
                <Box
                    position="absolute"
                    top="60px" // Adjust based on your layout
                    left="0"
                    bg="rgba(0, 0, 0, 0.9)"
                    color="white"
                    boxShadow="lg"
                    zIndex="1000"
                    p={4}
                    mt={"0.8rem"}
                    width="100%" // Full width for mobile
                >
                    <Text fontSize="lg" fontWeight="bold" mb={8} mt={8} align="center" color="white">Menu</Text> 
                    <VStack spacing={8} align="center" gap={14} mb={20}>
                        {[
                            { text: "Home", path: "/" },
                            { text: "About Us", path: "/about" },
                            { text: "Products", path: "/products", isDropdown: true }, // Products entry with dropdown
                            { text: "Projects", path: "/project" },
                            { text: "Downloads", path: "/download" },
                            { text: "Contact Us", path: "/contact" }
                        ].map((item) => (
                            <Box key={item.text} position="relative">
                                <Link 
                                    href={item.path} 
                                    color="white"
                                    _hover={{ bg: "teal.100" }}
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent default link behavior
                                        if (item.text === "Products") {
                                            setProductsMenuVisible(true); // Show products submenu
                                        } else {
                                            // Handle navigation for other items
                                            window.location.href = item.path; // Navigate to the path
                                        }
                                    }}
                                >
                                    {item.text}
                                </Link>
                            </Box>
                        ))}
                    </VStack>
                </Box>
            )}
            {productsMenuVisible && (
                <Box
                    position="absolute"
                    top="60px"
                    left="0"
                    bg="rgba(0, 0, 0, 0.8)"
                    color="white" 
                    boxShadow="md"
                    zIndex="1000"
                    p={4}
                    mt={"0.8rem"}
                    width="100%"
                >
            <Box align="end" onClick={() => {
                setProductsMenuVisible(false);
              }} >
                 <CloseIcon marginRight={2} />
                 </Box>
            <VStack spacing={4} align="center" mb={32}>
            <Text fontWeight="bold" mt={4} mb={4} color="white">Products</Text>
            <Link 
                onClick={() => {
                    setProductsMenuVisible(false);
                }} 
                        color="white"
                gap={0}
                display="flex" // Use flex to align icon and text
                alignItems="center" // Center the icon and text vertically
                p={2} // Add padding for clickable area
                borderRadius="md" // Rounded corners for links
                _hover={{ bg: "teal.100" }}
            >
              <ChevronLeftIcon marginRight={2} />
                Close submenu
            </Link>
            <VStack gap={10} align="center">
            {[
                { name: "Sliding Partitions", path: "/product/1" },
                { name: "Swing Partitions", path: "/product/2" },
                { name: "Flush Doors", path: "/product/3" },
                { name: "Bathroom & Wardrobes", path: "/product/4" },
                { name: "Shower Enclosures", path: "/product/5" },
                { name: "Led Mirrors", path: "/product/6" },
            ].map((subItem) => (
                <Link key={subItem.name} href={subItem.path} color="white" _hover={{ bg: "teal.100" }}>
                    {subItem.name}
                </Link>
            ))}</VStack>
        </VStack>
    </Box>
)}
            </>
          )} 
          <HStack spacing={8} display={{ base: "none", md: "flex" }}>
            {[
              { text: "Home", path: "/" },
              { text: "About Us", path: "/about" },
              { text: "Products", path: "#", isDropdown: true },
              // { text: "Channel Partners", path: "/channelPartners" },
              { text: "Projects", path: "/project" },
              { text: "Downloads", path: "/download" },
              { text: "Contact Us", path: "/contact" }
            ].map((item) => (
              item.isDropdown ? (
                <Box
                  key={item.text}
                  position="relative"
                  onMouseEnter={handleMenuEnter}
                  onMouseLeave={handleMenuLeave}
                >
                  <Link
                    className="link-hover"
                    href={item.path}
                    _hover={{
                      color: "teal.300",
                      transform: "translateY(-2px)",
                    }}
                    transition="all 0.2s ease"
                  >
                    {item.text}
                  </Link>
                  {menuVisible && (
                    <Flex
                      position="absolute"
                      top="100%"
                      left="-100%"
                      bg="rgba(0, 0, 0, 0.95)"
                      color="white"
                      borderRadius="md"
                      boxShadow="xl"
                      zIndex="1000"
                      p={6}
                      minWidth="458px"
                      backdropFilter="blur(8px)"
                      animation="fadeIn 0.3s ease-in-out"
                    >
                      <VStack id="productList" align="start" spacing={4}>
                        {[
                          { name: "Sliding Partitions", path: "/product/1" },
                          { name: "Swing Partitions", path: "/product/2" },
                          { name: "Flush Doors", path: "/product/3" },
                          { name: "Bathroom & Wardrobes", path: "/product/4" },
                          { name: "Shower Enclosures", path: "/product/5" },
                          { name: "Led Mirrors", path: "/product/6" },
                        ].map((subItem) => (
                          <Link
                            key={subItem.name}
                            href={subItem.path}
                            onMouseEnter={() => setHoveredItem(subItem.name)}
                            _hover={{
                              color: "teal.300",
                              transform: "translateX(10px)",
                            }}
                            transition="all 0.2s ease"
                            fontSize="md"
                            fontWeight="medium"
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </VStack>
                      <Box
                        width="95%"
                        pl={6}
                        transition="all 0.3s ease"
                      >
                        <Image
                          src={hoveredItem ? productImages[hoveredItem] : glass1}
                          alt={hoveredItem || "Product Image"}
                          borderRadius="md"
                          boxSize="300px"
                          objectFit="cover"
                          transition="all 0.3s ease"
                          _hover={{ transform: "scale(1.05)" }}
                          style={{
                            opacity: hoveredItem ? 1 : 0.8,
                            transform: hoveredItem ? "scale(1)" : "scale(0.95)",
                          }}
                        />
                      </Box>
                    </Flex>
                  )}
                </Box>
              ) : (
                <Link
                  key={item.text}
                  href={item.path}
                  className="link-hover"
                  _hover={{
                    color: "teal.300",
                    transform: "translateY(-2px)",
                  }}
                  transition="all 0.2s ease"
                >
                  {item.text}
                </Link>
              )
            ))}
          </HStack>
        </Flex> */}
      </Box>
      <Box
        // bg={useColorModeValue(
        //   "linear-gradient(to bottom, #f9f9f9, #e0e0e0)",
        //   "#000000"
        // )}
      >
        <Box
          w="100%"
          position="relative"
          overflow="hidden"
          mt={{ base: "60px", md: "70px" }}
        >
          <Box
            position="absolute"
            w="100%"
            h="100%"
            bgGradient={{
              base: "linear(to-b, rgba(0,0,0,0.7), rgba(0,0,0,0.5))",
              md: "linear(to-r, black, transparent)",
            }}
            opacity={fadeOut ? 0 : { base: 0.85, md: 0.7 }}
            transition="opacity 2s ease"
            zIndex="1"
          />
{/* <Box position="relative" w="100%" h="100vh" overflow="hidden"> */}
      {/* <video
        src={enso}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "100%",
          height: "100%",
        }}
      /> */}

      {/* Overlay content */}
      {/* <Box
        position="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="blackAlpha.600" // optional overlay
        color="white"
        fontSize="3xl"
        fontWeight="bold"
      >
        Hello from Chakra
      </Box> */}
    {/* </Box> */}

          <Image
            src={currentItem.src}
            alt={currentItem.alt}
            width="100%"
            height={{ base: "auto", sm: "400px", md: "650px", lg: "680px" }}
            transition="transform 0.5s ease"
            transform={showBackground ? "scale(1.05)" : "scale(1)"}
            loading="eager"
          />
          <Box
            position="absolute"
            top={{ base: "18%", sm: "30%", md: "40%" }}
            left="50%"
            transform="translate(-50%, -50%)"
            zIndex="2"
            textAlign="center"
            color="white"
            width={{ base: "90%", sm: "85%", md: "80%", lg: "auto" }}
            px={{ base: 4, md: 6 }}
          >
            <Flex
              minH="100vh"
              align="center"
              justify="center"
              textAlign="center"
              mt={{base:"12rem"}}
            >
            <Box
              display="inline-block"
              px={{ base: 4, md: 8 }}
              py={{ base: 3, md: 4 }}
              bg="rgba(0, 0, 0, 0.2)"
              backdropFilter="blur(1px)"
              borderRadius="md"
            >
            <MotionBox
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <Heading
                fontSize={{ base: "1xl", sm: "4xl", md: "5xl", lg: "5xl" }}
                fontWeight="300"
                fontFamily="'Playfair Display', serif"
                letterSpacing={{ base: "0.1em", md: "0.15em" }}
                mb={{ base: 0, md: 4 }}
                mt={{ base: 0, sm: 20, md: 4 }}
                textTransform="uppercase"
                lineHeight={{ base: "1.2", md: "1.4" }}
                textShadow="1px 2px 2px rgba(0,0,0,0.3)"
                bgGradient="linear(to-r, white, #E5E5E5)"
                bgClip="text"
              >
                Luxury Redefined
              </Heading>
            </MotionBox>
            <MotionBox
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <Text
                fontSize={{ base: "1xl", sm: "1xl", md: "2xl", lg: "2xl" }}
                maxW={{ base: "100%", md: "800px" }}
                mx="auto"
                opacity="0.9"
                letterSpacing={{ base: "0.05em", md: "0.1em" }}
                lineHeight={{ base: "1.6", md: "1.8" }}
                fontWeight="medium"
                textShadow="1px 1px 2px rgba(0,0,0,0.2)"
              >
                Experience the perfect blend of elegance and innovation
              </Text>
            </MotionBox></Box></Flex>
            <MotionBox
              position="relative"
              // position="absolute"
              bottom={{
                base: "-65px",
                sm: "-150px",
                md: "-230px",
                lg: "-220px",
                xl: "-250px",
              }}
              // bottom="-140%"
              // left="46%"
              // // left={{base:"41%",sm:"48%",md:"46%"}}
              ml={2}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              transform="translateX(-50%)"
              // transform="translateX(0)"
              animate={{
                y: [0, 10, 0],
                opacity: showScroll ? 1 : 0,
              }}
              transition={{
                y: { repeat: Infinity, duration: 1.5 },
                opacity: { duration: 0.3 },
              }}
              // display={{ base: "block", md: "block" }}
            >
              <VStack spacing={{ base: 0, md: 2 }}>
                <Text fontSize={{ base: "0.55rem", md: "1rem" }} opacity={0.8}>
                  Scroll Down
                </Text>
                <Icon
                  as={ChevronDownIcon}
                  w={{ base: 4, md: 6 }}
                  h={{ base: 2, md: 6 }}
                />
              </VStack>
            </MotionBox>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          mt={{ base: 10, md: "5rem" }}
          // bg={useColorModeValue("#000000", "#000000")}
        >
          <Heading
            as="h1"
            color="#000000"
            fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
            fontFamily="'Playfair Display', serif"
            fontWeight="light"
            letterSpacing="0.2em"
            textAlign="center"
            textTransform="uppercase"
            mb={{ base: 6, md: 12 }}
            px={{ base: 4, md: 0 }}
            lineHeight={{ base: "1.2", md: "1.4" }}
          >
            Why Enso
          </Heading>
          <Text
            fontSize={{ base: "md", sm: "lg", md: "xl" }}
            color="#000000"
            textAlign="center"
            fontFamily="'Arial', sans-serif"
            mb={{ base: 6, md: 10 }}
            maxWidth={{ base: "95%", md: "700px" }}
            px={{ base: 4, md: 6 }}
            lineHeight={{ base: "1.6", md: "1.8" }}
          >
            Enso materials guarantees that you'll experience unmatched beauty and
            security. Discover our wide range of services designed to suit all
            your glass and door requirements. Whether it's for your home or
            business, we deliver quality and reliability.
          </Text>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            // bg={useColorModeValue("#000000", "#000000")}
            mb="3rem"
          >
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 3 }}
              spacing={{ base: 10, lg: 14 }}
              maxW="1200px"
              mx="auto"
              px={{ base: 6, md: 8 }}
              gap={{ base: 0 }}
            >
              {[
                {
                  title: "Premium Quality",
                  description:
                    "Crafted with the finest materials and attention to detail",
                  icon: "🌟",
                },
                {
                  title: "Innovative Design",
                  description:
                    "Contemporary solutions meeting modern lifestyle needs",
                  icon: "💡",
                },
                {
                  title: "Expert Craftsmanship",
                  description: "Skilled artisans with years of experience",
                  icon: "🛠️",
                },
                {
                  title: "Customization",
                  description: "Tailored solutions to match your unique style",
                  icon: "✨",
                },
                {
                  title: "Sustainability",
                  description:
                    "Eco-friendly materials and responsible practices",
                  icon: "🌿",
                },
                {
                  title: "Lifetime Support",
                  description: "Dedicated service and maintenance assistance",
                  icon: "🤝",
                },
              ].map((feature, index) => (
                <Box
                  key={index}
                  pl={10}
                  pt={10}
                  pr={10}
                  pb={{ base: 1, md: 10 }}
                  borderRadius="lg"
                  transition="all 0.3s ease"
                  _hover={{
                    transform: "translateY(-5px)",
                    boxShadow: "xl",
                    bg: featureBoxBorder,
                    cursor: "pointer",
                  }}
                >
                  <Text fontSize="4xl" mb={4}>
                    {feature.icon}
                  </Text>
                  <Heading
                    as="h3"
                    fontSize={{ base: "xl", md: "2xl" }}
                    mb={4}
                    fontFamily="'Montserrat', sans-serif"
                    fontWeight="600"
                    color={featureHeadingColor}
                  >
                    {feature.title}
                  </Heading>
                  <Text
                    color={featureTextColor}
                    fontSize={{ base: "md", md: "lg" }}
                    lineHeight="1.8"
                    fontFamily="'Montserrat', sans-serif"
                  >
                    {feature.description}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </Box>
          <Box width={{ base: "100%", md: "auto" }} px={{ base: 4, md: 0 }}>
            <Heading
              as="h1"
              // color="teal.600"
              fontFamily="'Times New Roman', serif"
              fontWeight="bold"
              fontSize={{ base: "xl", sm: "2xl", md: "3xl" }}
              letterSpacing={{ base: "wide", md: "wider" }}
              textAlign="center"
              mb={{ base: "2rem", md: "3rem" }}
              textTransform="uppercase"
              textShadow="2px 2px 6px rgba(0, 0, 0, 0.2)"
              _hover={{
                // color: "teal.500",
                textShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
              }}
            >
              Explore Our Services
            </Heading>
          </Box>
        </Box>
        <Box
          position="relative"
          width="100%"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <Center>
            <Image
              src={ImageItem.src}
              alt={ImageItem.alt}
              borderRadius="md"
              objectFit="cover"
              width={{ base: "100%", md: "100%", lg: "100%" }} // Full width for all sizes
              height={{ base: "auto", md: "400px", lg: "550px" }}
            />
          </Center>
          {isHovering && (
            <>
              <IconButton
                icon={<ChevronLeftIcon color="white" />}
                onClick={() => {
                  handlePrevious();
                }}
                aria-label="Previous"
                position="absolute"
                left={{ base: "5", md: "20" }}
                top="50%"
                transform="translateY(-50%)"
                zIndex={1}
                variant="solid"
                bg="#000000"
                color="white"
                boxSize={{ base: "40px", md: "50px" }}
                borderRadius="full"
                // transition="all 0.3s ease-in-out"
                _hover={{
                  bg: "white.500",
                  // transform: "scale(1.1)",
                }}
                _active={{
                  bg: "white.800",
                  // transform: "scale(0.95)",
                }}
                _focus={{
                  boxShadow: "0 0 0 4px rgba(0, 0, 0, 0.2)",
                }}
              />
              <IconButton
                icon={<ChevronRightIcon color="white" />}
                onClick={() => {
                  handleNext();
                }}
                aria-label="Next"
                position="absolute"
                right={{ base: "5", md: "20" }}
                top="50%"
                transform="translateY(-50%)"
                zIndex={1}
                variant="solid"
                bg="#000000"
                color="white"
                boxSize={{ base: "40px", md: "50px" }}
                borderRadius="full"
                _hover={{
                  bg: "#000000",
                }}
                _active={{
                  bg: "#000000",
                }}
                _focus={{
                  boxShadow: "0 0 0 4px rgba(0, 0, 0, 0.2)",
                }}
              />
            </>
          )}
        </Box>
        {/* <Box position="relative" width="100%">
          <Heading
            as="h1"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            size="2xl"
            mt={10}
            mb={6}
            color="teal.600"
          >
            Our Products
          </Heading>
          <Center>
            <Image
              src={currentItem.src}
              alt={currentItem.alt}
              borderRadius="md"
              objectFit="cover"
              height="550px"
              width="100%"
            />
          </Center>
          <IconButton
            icon={<ChevronLeftIcon />}
            onClick={handlePrevious}
            aria-label="Previous"
            position="absolute"
            left={20}
            top="50%"
            transform="translateY(-50%)"
            zIndex={1}
            variant="outline"
            colorScheme="teal"
            size="lg"
            borderRadius="full"
            _hover={{ bg: "teal.100" }}
            _active={{ bg: "teal.200" }}
            _focus={{ boxShadow: "0 0 0 3px teal.300" }}
          />
          <IconButton
            icon={<ChevronRightIcon />}
            onClick={handleNext}
            aria-label="Next"
            position="absolute"
            right={20}
            top="50%"
            transform="translateY(-50%)"
            zIndex={1}
            variant="outline"
            colorScheme="teal"
            size="lg"
            borderRadius="full"
            _hover={{ bg: "teal.100" }}
            _active={{ bg: "teal.200" }}
            _focus={{ boxShadow: "0 0 0 3px teal.300" }}
          />
        </Box> */}
        <Box
          position="relative"
          // borderRadius="2xl"
          overflow="hidden"
          py={{ base: 16, md: 24 }}
          px={{ base: 6, md: 14 }}
          // boxShadow="0px 0px 24px 0px rgba(0, 1, 0, 0.2)"
          mt={{ base: "4rem", md: "4rem" }}
        >
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            // bgGradient="linear(135deg, rgba(59, 130, 246, 0.15), rgba(96, 165, 250, 0.2), rgba(59, 130, 246, 0.15))"
            // bgGradient="linear(135deg, rgba(100, 116, 139, 0.08), rgba(148, 163, 184, 0.12), rgba(100, 116, 139, 0.08))"
            // bgGradient="linear(135deg, rgba(71, 85, 105, 0.1), rgba(100, 116, 139, 0.15), rgba(71, 85, 105, 0.1))"
          />
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            backdropFilter="blur(8px)"
            backgroundColor="rgba(255, 255, 255, 0.02)"
          />
          <VStack spacing={{ base: 8, md: 16 }} position="relative" zIndex="1">
            <Heading
              size={{ base: "lg", md: "xl" }}
              textAlign="center"
              color="#000000"
              fontFamily="'Playfair Display', serif"
              fontWeight="light"
              letterSpacing="wider"
              textTransform="uppercase"
              _after={{
                content: '""',
                display: "block",
                height: "2px",
                background:
                  "linear-gradient(to right, transparent, rgba(212, 175, 55, 0.7), transparent)",
                margin: "20px auto 0",
              }}
            >
              Our Legacy in Numbers
            </Heading>
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 4 }}
              spacing={{ base: 8, md: 8 }}
              width="100%"
            >
              {[
                { number: "700+", label: "Happy Customers" },
                { number: "25+", label: "Premium Products" },
                { number: "15+", label: "Pan India Presence" },
                { number: "5000+", label: "Sq. ft. Delivered" },
              ].map((stat, index) => (
                <VStack
                  key={index}
                  spacing={4}
                  p={6}
                  position="relative"
                  _after={{
                    content: '""',
                    position: "absolute",
                    right: "-1px",
                    top: "20%",
                    height: "60%",
                    width: "1px",
                    background:
                      "linear-gradient(to bottom, transparent, rgba(0,0,0,0.1), transparent)",
                    display: {
                      base: "none",
                      lg: index !== 3 ? "block" : "none",
                    },
                  }}
                >
                  <Text
                    fontSize={{ base: "5xl", md: "6xl" }}
                    fontWeight="light"
                    bgGradient="linear(to-r, #B8860B, #DAA520)"
                    bgClip="text"
                    fontFamily="'Montserrat', sans-serif"
                    position="relative"
                    _after={{
                      content: '""',
                      position: "absolute",
                      bottom: "-8px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "40px",
                      height: "2px",
                      background:
                        "linear-gradient(to right, transparent, rgba(184, 134, 11, 0.5), transparent)",
                      opacity: 0.7,
                    }}
                  >
                    {stat.number}
                  </Text>
                  <Text
                    color="#000000"
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight="medium"
                    letterSpacing="wide"
                    textTransform="uppercase"
                  >
                    {stat.label}
                  </Text>
                </VStack>
              ))}
            </SimpleGrid>
          </VStack>
        </Box>
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
          fontFamily="'Playfair Display', serif"
          fontWeight="300"
          textAlign="center"
          color={featureHeadingColor}
          letterSpacing="0.1em"
          mt={{ base: 10, md: 20 }}
        >
          Featured Collections
        </Heading>
        <ProductDetails />
        <Footer />
      </Box>
    </Box>
  );
};

export default Home;
